import { render, staticRenderFns } from "./rIndex1.vue?vue&type=template&id=773ff024&scoped=true&"
import script from "./rIndex1.vue?vue&type=script&lang=js&"
export * from "./rIndex1.vue?vue&type=script&lang=js&"
import style0 from "./rIndex1.vue?vue&type=style&index=0&lang=less&"
import style1 from "./rIndex1.vue?vue&type=style&index=1&id=773ff024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ff024",
  null
  
)

export default component.exports